import { useState, useEffect } from "react";
import { ArrowUpRight } from "lucide-react";

const COURSE_IMG =
  "https://images.unsplash.com/photo-1561251224-e393160cd769?q=80&w=1170&auto=format&fit=crop";

export default function TeeBooking() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    date: "",
    tee_time: "",
    number_of_buggies: 1,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
  "https://my-website-production-d666.up.railway.app/api/forms/buggy",
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(form),
  }
);

const text = await response.text();

console.log("Status:", response.status);
console.log("Response:", text);

if (response.ok) {
        setMessage("Buggy request submitted successfully.");

        setForm({
          name: "",
          phone: "",
          email: "",
          date: "",
          tee_time: "",
          number_of_buggies: 1,
        });
      } else {
        setMessage("Submission failed.");
      }
    } catch (err) {
  console.error(err);
  setMessage("Unable to submit request.");
}
  };

  useEffect(() => {
    const scriptSrc = "https://tally.so/widgets/embed.js";

    const loadEmbeds = () => {
      if (typeof Tally !== "undefined") {
        window.Tally.loadEmbeds();
      } else {
        document
          .querySelectorAll("iframe[data-tally-src]:not([src])")
          .forEach((iframe) => {
            iframe.src = iframe.dataset.tallySrc;
          });
      }
    };

    if (typeof Tally !== "undefined") {
      loadEmbeds();
    } else if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.onload = loadEmbeds;
      script.onerror = loadEmbeds;
      document.body.appendChild(script);
    }
  }, []);
  return (
  <section
    id="tee-booking"
    data-testid="tee-booking-section"
    className="bg-white py-24 md:py-32 lg:py-40"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">

        {/* LEFT COLUMN */}
        <div className="lg:col-span-7">
          <span className="section-eyebrow">
            01 · Tee &amp; Buggy Concierge
          </span>

          <h2 className="font-serif-luxury text-4xl md:text-5xl lg:text-6xl text-[#0F4C3A] mt-5 leading-[1.05] tracking-tight">
            Outstanding Golf on the
            <span className="block italic text-gold-metallic">
              Gower Peninsula
            </span>
          </h2>

          <p className="text-[#4A4A4A] mt-6 max-w-xl leading-relaxed">
            Reserve your time on Swansea's most storied fairways. Members and
            visitors alike can secure tee slots through our trusted BRS booking
            concierge.
          </p>

          <div className="mt-10 image-frame border border-[#CBA153]/30">
            <img
              src={COURSE_IMG}
              alt="Sunrise over the championship fairways at The Gower Golf Club, Swansea"
              className="w-full h-[320px] md:h-[420px] object-cover"
            />
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="member-tee-booking-btn"
              href="https://members.brsgolf.com/gower/login"
              target="_blank"
              rel="noopener noreferrer"
              className="ggc-btn-primary group"
            >
              Member Tee Booking
              <ArrowUpRight
                size={16}
                strokeWidth={1.5}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>

            <a
              data-testid="visitor-tee-booking-btn"
              href="https://visitors.brsgolf.com/gower#/course/1"
              target="_blank"
              rel="noopener noreferrer"
              className="ggc-btn-gold group"
            >
              Visitor Tee Booking
              <ArrowUpRight
                size={16}
                strokeWidth={1.5}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>

          {/* BUGGY INFORMATION BOX */}
          <div className="mt-[750px] bg-[#F8F6F0] border border-[#CBA153]/20 p-8 md:p-10 rounded-sm">
            <p className="section-eyebrow">
              Golf Buggy Hire
            </p>

            <h3 className="font-serif-luxury text-3xl md:text-4xl text-[#0F4C3A] mt-2">
              Explore the Course
              <span className="block italic text-gold-metallic">
                in Comfort
              </span>
            </h3>

            <p className="mt-5 text-[#4A4A4A] leading-relaxed">
              Golf buggies provide a comfortable and convenient way to enjoy
              your round while taking in the scenery of the Gower Peninsula.
              Complete the Annual Buggy Permit before making buggy booking
              requests throughout the year.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
              <div>✓ Comfortable travel around the course</div>
              <div>✓ Suitable for all ages and abilities</div>
              <div>✓ Simple online booking request</div>
              <div>✓ Subject to availability</div>
            </div>

            <img
              src="https://images.unsplash.com/photo-1595119322637-fc1c32304a51?q=80&w=1209&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Golf buggy"
              className="w-full h-64 object-cover rounded-sm mt-8"
            />

            <p className="mt-6 text-sm text-[#4A4A4A] italic">
              Please ensure you have completed the Annual Buggy Permit before submitting a buggy booking request.
            </p>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="lg:col-span-5">
          <div className="bg-[#FAFAFA] border border-[#CBA153]/30 p-6 md:p-8 h-full flex flex-col">
            <p className="section-eyebrow">
              Annual Buggy Permit
            </p>

            <h3 className="font-serif-luxury text-3xl md:text-4xl text-[#0F4C3A] mt-3 mb-2 leading-tight">
              Annual Buggy Permit
            </h3>

            <p className="text-sm text-[#4A4A4A] mb-6">
              Complete this form once each year before submitting buggy booking requests.
            </p>

            <div className="w-full flex-grow min-h-[700px] bg-transparent">
                            <iframe
                data-tally-src="https://tally.so/embed/q4v9vG?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                loading="lazy"
                width="100%"
                height="1786"
                style={{ border: 0, margin: 0, minHeight: "700px" }}
                title="Annual Buggy Permit"
              />
            </div>

            {/* Buggy Booking Request */}
            <div className="border-t border-[#CBA153]/30 mt-10 pt-8">
              <p className="section-eyebrow">
                Buggy Booking Request
              </p>

              <h3 className="font-serif-luxury text-2xl text-[#0F4C3A] mt-2">
                Request a Golf Buggy
              </h3>

              <p className="text-sm text-[#4A4A4A] mb-6">
                Complete the form below and a member of staff will confirm availability by email.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">

                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="w-full border border-[#CBA153]/30 p-3"
                  required
                />

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full border border-[#CBA153]/30 p-3"
                  required
                />

                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Telephone Number"
                  className="w-full border border-[#CBA153]/30 p-3"
                  required
                />

                <input
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  className="w-full border border-[#CBA153]/30 p-3"
                  required
                />

                <input
                  type="time"
                  name="tee_time"
                  value={form.tee_time}
                  onChange={handleChange}
                  className="w-full border border-[#CBA153]/30 p-3"
                  required
                />

                <select
                  name="number_of_buggies"
                  value={form.number_of_buggies}
                  onChange={handleChange}
                  className="w-full border border-[#CBA153]/30 p-3"
                >
                  <option value="1">1 Buggy</option>
                  <option value="2">2 Buggies</option>
                  <option value="3">3 Buggies</option>
                  <option value="4">4 Buggies</option>
                </select>

                <button
                  type="submit"
                  className="ggc-btn-primary w-full justify-center"
                >
                  Submit Booking Request
                </button>

                {message && (
                  <p className="text-sm text-[#0F4C3A]">
                    {message}
                  </p>
                )}

              </form>
            </div>

          </div>
        </div>

      </div>
    </div>
  </section>
);
}
